import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {MerchantService} from '../pages/merchant/merchant.service';
import {Route, Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiUrl + '/api/auth'; // Replace with your actual API URL
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser$: Observable<any>;

  constructor(private http: HttpClient, private merchantService: MerchantService, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(this.getCurrentUserFromLocalStorage());
    this.currentUser$ = this.currentUserSubject.asObservable();
  }

  login(username: string, password: string): Observable<any> {
    const body = {username: username, password: password};
    return this.http.post<any>(this.apiUrl + '/login', body).pipe(
      tap((response) => {
        this.setCurrentUser(response.user);
        this.saveCurrentUserToLocalStorage(response.user);
      })
    );
  }

  logout(): Observable<any> {
    this.removeDataFromLocalStorage();
    this.currentUserSubject.next(null);
    return this.http.post<any>(this.apiUrl + '/logout', {}).pipe(tap(() => {}));
  }

  setCurrentUser(user: any) {
    this.currentUserSubject.next(user);
  }

  getCurrentUser(): any {
    this.currentUserSubject.next(this.getCurrentUserFromLocalStorage());
    return this.currentUserSubject.value;
  }

  isAuthenticated(): boolean {
    return !!this.getCurrentUser();
  }

  getLastLoginDate(): Date {
    const logindate = localStorage.getItem('dposLastLoginDate');
    return logindate ? new Date(JSON.parse(logindate)) : null;
  }

  private getCurrentUserFromLocalStorage(): any {
    const userJson = localStorage.getItem('dposCurrentUser');
    return userJson ? JSON.parse(userJson) : null;
  }

  private saveCurrentUserToLocalStorage(user: any) {
    localStorage.setItem('dposCurrentUser', JSON.stringify(user));
    localStorage.setItem('dposLastLoginDate', JSON.stringify(new Date()));
  }

  private removeDataFromLocalStorage() {
    localStorage.clear();

    this.router.navigateByUrl('login');
  }
}
